import $ from 'jquery';
import * as PlotlyJS from 'plotly.js-dist-min';

// Expose the module jQuery instance globally so that plugins using
// the browser-globals UMD branch (jQuery UI) or AMD branch find
// the same instance that ES-module code uses.
(window as any).jQuery = $;
(window as any).$ = $;

// Plotly must be on window before plotly_renderers executes, because
// the patched UMD wrapper reads window.Plotly at require-time.
(window as any).Plotly = PlotlyJS;

// require() is NOT hoisted (unlike import), so window.jQuery and
// window.Plotly are guaranteed to be set before these plugins execute.
// jQuery UI: uses factory(jQuery) — needs the global.
// pivottable: uses require("jquery") — esbuild resolves to the same bundled module.
require('jquery-ui-dist/jquery-ui');
require('pivottable/dist/pivot');
require('pivottable/dist/c3_renderers');
require('pivottable/dist/d3_renderers');
require('pivottable/dist/export_renderers');
require('pivottable/dist/plotly_renderers');

export default $;
